import { AtIcon } from '@curran-catalog/curran-atomic-library'

const LoadingView = ({ message }: { message: string | undefined }) => (
  <div className="flex flex-col pb-12 tw-justify-center h-[350px]">
    <div className="mb-6 mx-auto">
      <AtIcon type="spinner" size={96} />
    </div>
    <div className="mx-auto">
      <p className="text-center my-4 text-xl">{message ? message : 'Loading...'}</p>
    </div>
  </div>
)

export default LoadingView
